/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_Catalog_PreviewInputs */

const cs_property_list_catalog_preview = /** @type {(inputs: Property_List_Catalog_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled katalogového PDF`)
};

const en_property_list_catalog_preview = /** @type {(inputs: Property_List_Catalog_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview catalog PDF`)
};

/**
* | output |
* | --- |
* | "Preview catalog PDF" |
*
* @param {Property_List_Catalog_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_catalog_preview = /** @type {((inputs?: Property_List_Catalog_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_Catalog_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_catalog_preview(inputs)
	return cs_property_list_catalog_preview(inputs)
});